import api from 'api/api.config';

const getCustomLogicPath = (
  userId: string,
  clientId: string | number
): string => `/${userId}/clients/${clientId}/custom-logic`;

export const getCustomLogic = async (
  userId: string,
  clientId: string | number
): Promise<unknown> => {
  const response = await api.get(getCustomLogicPath(userId, clientId));

  return response.data;
};
